import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
  toggleClick() {
    this.$emit('toggleClick');
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isActive", void 0);
default_1 = __decorate([Component({
  name: 'Hamburger'
})], default_1);
export default default_1;